module.exports = "/packs/images/navigation/juul-nora-b04fa47e188e6a7be5ce8b9588c70ca4.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/navigation/juul-nora.png
// module id = 1815
// module chunks = 0